import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { ActionButton } from './ActionButton'
import { useStateValue } from '@State'
import {
  RemoveCourseMemberModal,
  removeCourseMemberItem,
} from './RemoveCourseMemberModal'
import { CanvasActions, canvasItems } from './CanvasActions'
import { ForceReadingModal, forceReadingItem } from './ForceReadingModal'
import { ForceVideoModal, forceVideoItem } from './ForceVideoModal'

export const ActionButtonPeople = ({ account_id, user_full_name, user_id }) => {
  const [currentState] = useStateValue()
  const items = [
    ...(currentState.supportDashboard
      ? [{
          id: 'support-dashboard',
          label: 'Support Dashboard',
          icon: 'fa-light fa-question-circle',
          href: `/account/support_dashboard/${currentState.coursenum}/${account_id}/`,
        }]
      : []),
    ...(currentState.courseLms ? canvasItems : []),
    { id: 'analytics-heading', label: 'ANALYTICS', heading: true },
    forceReadingItem,
    forceVideoItem,
    { id: 'remove-separator', separator: true },
    removeCourseMemberItem,
  ]

  return (
    <ActionButton items={items}>
      {({ activeAction, close }) => (
        <Fragment>
          <RemoveCourseMemberModal
            user_full_name={user_full_name}
            user_id={user_id}
            show={activeAction === removeCourseMemberItem.id}
            close={close}
          />
          {currentState.courseLms && (
            <CanvasActions
              user_id={user_id}
              user_full_name={user_full_name}
              activeAction={activeAction}
              close={close}
            />
          )}
          <ForceReadingModal
            user_full_name={user_full_name}
            user_id={user_id}
            show={activeAction === forceReadingItem.id}
            close={close}
          />
          <ForceVideoModal
            videoData={currentState.videoData}
            user_full_name={user_full_name}
            user_id={user_id}
            show={activeAction === forceVideoItem.id}
            close={close}
          />
        </Fragment>
      )}
    </ActionButton>
  )
}

ActionButtonPeople.propTypes = {
  user_id: PropTypes.string,
  account_id: PropTypes.string,
  user_full_name: PropTypes.string,
}
